/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagePackagePageResponse } from '../../models/page-package-page-response';

export interface GetPackages$Params {

/**
 * There are cases when we need to filter on packages by their ID
 */
  id?: string;

/**
 * Filter on name
 */
  name?: string;

/**
 * Filter on unit
 */
  unit?: 'LITERS' | 'KILOGRAMS';

/**
 * Filter on amount
 */
  amount?: number;

/**
 * Filter on mainType of package
 */
  mainType?: 'STANDALONE' | 'COLLECTION';

/**
 * Filter on subType of package
 */
  subType?: string;

/**
 * Filter on publication status of packages
 */
  status: 'PUBLISHED' | 'DRAFT' | 'REJECTED' | 'ONGOING';

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getPackages(http: HttpClient, rootUrl: string, params: GetPackages$Params, context?: HttpContext): Observable<StrictHttpResponse<PagePackagePageResponse>> {
  const rb = new RequestBuilder(rootUrl, getPackages.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('name', params.name, {});
    rb.query('unit', params.unit, {});
    rb.query('amount', params.amount, {});
    rb.query('mainType', params.mainType, {});
    rb.query('subType', params.subType, {});
    rb.query('status', params.status, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagePackagePageResponse>;
    })
  );
}

getPackages.PATH = '/packages';
